
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { PEOVerification } from '@/types/peo.types';

interface VerificationCardProps {
  verification: PEOVerification;
  onVerify: (userId: string, status: 'approved' | 'rejected', reason?: string) => Promise<void>;
  processingId: string | null;
}

export const VerificationCard = ({ verification, onVerify, processingId }: VerificationCardProps) => {
  return (
    <Card key={verification.id}>
      <CardContent className="flex items-center justify-between p-6">
        <div>
          <h3 className="font-semibold">
            {verification.profile?.first_name || 'Unknown'} {verification.profile?.last_name || 'User'}
          </h3>
          <p className="text-sm text-muted-foreground">
            {verification.profile?.email || 'Unknown email'}
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            Requested: {new Date(verification.created_at).toLocaleDateString()}
          </p>
        </div>

        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            className="text-destructive"
            onClick={() => onVerify(verification.user_id, 'rejected', 'Does not meet requirements')}
            disabled={!!processingId}
          >
            {processingId === verification.user_id ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <XCircle className="h-4 w-4 mr-1" />
            )}
            Reject
          </Button>
          <Button
            size="sm"
            onClick={() => onVerify(verification.user_id, 'approved')}
            disabled={!!processingId}
          >
            {processingId === verification.user_id ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <CheckCircle2 className="h-4 w-4 mr-1" />
            )}
            Approve
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
